import {
  apiRequest,
  PNSlistCPNS,
} from "../../../../../services/adapters/kepegawaian/DokumenPNSService";

class DataTableRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      PNSlistCPNS,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };
}

export default DataTableRepository;
